import styled from 'styled-components'

type Props = {
  error?: boolean
}

export default styled.label(({ error = false }: Props) => ({
  color: error ? 'red' : 'rgba(0, 0, 0, 0.54)',
  fontSize: 16,
  padding: '10px 0 0 0',
  display: 'inline-block',
}))
